/**
 * Helper: SVG map
 * -----------------------------------------------------------------------------
 * Store for SVG icon paths to use in render functions
 * - Use SVGOMG to compress files
 * - Remove any inline fill colours
 * - Add closing tags to suppress warnings on HTML5 compatibility
 * - Add correct BEM class names
 */
const minus = `
  <svg xmlns="http://www.w3.org/2000/svg" width="9.801" height="0.5" viewBox="0 0 9.801 0.5">
    <g id="Group_598" data-name="Group 598" transform="translate(0 -4.791)">
      <line id="Line_17763" data-name="Line 17763" x2="9.801" transform="translate(0 5.041)" fill="none" stroke="#000" stroke-width="0.5"/>
    </g>
  </svg>
`;

const plus = `
  <svg id="Group_595" data-name="Group 595" xmlns="http://www.w3.org/2000/svg" width="9.801" height="9.801" viewBox="0 0 9.801 9.801">
    <line id="Line_17763" data-name="Line 17763" x2="9.801" transform="translate(0 5.041)" fill="none" stroke="#000" stroke-width="0.5"/>
    <line id="Line_17764" data-name="Line 17764" x2="9.801" transform="translate(5.041 0) rotate(90)" fill="none" stroke="#000" stroke-width="0.5"/>
  </svg>
`;

const remove = `
  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon__close" viewBox="0 0 36 36">
    <path d="M12.51 8.46l-3.17 3.17 1.62 1.62 4 4.08-4 4-1.62 1.55 3.17 3.24 1.62-1.62 4.07-4.07 4.01 4.07 1.55 1.62L27 22.88l-1.62-1.55-4.07-4 4.07-4.08L27 11.63l-3.24-3.17-1.55 1.62-4.01 4.01-4.07-4.01-1.62-1.62z"></path>
  </svg>
`;

export const misc = {
  minus,
  plus,
  remove,
};
